export const faqData = [
  {
    keywords: ["hi", "hello", "hey", "start", "help", "start"],
    question: "How can I help you today?",
    answer: "I'm here to help! You can ask me about:\n\n• How to register as a supplier\n• How to post a requirement\n• Cities we serve\n• Products available\n• Pricing and fees\n• Contact support\n\nJust type your question or choose from the options above.",
  },
  {
    keywords: ["register", "signup", "supplier registration", "join", "list my business", "supplier register"],
    question: "How do I register as a supplier?",
    answer: "To register as a supplier:\n\n1. Go to /supplier/login\n2. Click 'Register as Supplier'\n3. Fill in your business details\n4. Add your city and products\n5. Upload GST & business documents\n\nThe process takes about 5 minutes. Our team verifies within 24 hours.",
  },
  {
    keywords: ["post", "requirement", "enquiry", "rfq", "quote", "need", "buy", "purchase", "materials"],
    question: "How do I post a requirement?",
    answer: "To post a requirement:\n\n1. Go to /materials\n2. Select scaffolding materials you need\n3. Add quantities and specifications\n4. Enter your project location\n5. Set your timeline\n\nYou'll receive quotes from verified suppliers within 24 hours.",
  },
  {
    keywords: ["city", "cities", "location", "serve", "gurgaon", "delhi", "mumbai", "bangalore"],
    question: "Which cities do you serve?",
    answer: "We currently serve 20+ cities including:\n\n• Gurgaon\n• Delhi NCR\n• Mumbai\n• Ahmedabad\n• Hyderabad\n• Bangalore\n• Chennai\n• Kolkata\n• Pune\n\nWe're rapidly expanding to more cities. Contact us to check if we serve your location.",
  },
  {
    keywords: ["product", "materials", "scaffolding", "shuttering", "cement", "tmt bar", "h frame", "cuplock"],
    question: "What products are available?",
    answer: "Currently available:\n\n• Scaffolding systems\n• Shuttering plates\n• Cuplock systems\n• H-frame systems\n\nComing soon:\n• Cement\n• TMT bars\n• JCB rental\n• Transport services",
  },
  {
    keywords: ["price", "cost", "fee", "charge", "free", "pricing", "commission"],
    question: "Is there any charge to use the platform?",
    answer: "For Buyers:\nPosting requirements and receiving quotes is COMPLETELY FREE.\n\nFor Suppliers:\nWe charge a small commission on successful orders. Registration is free.\n\nContact our team for detailed pricing.",
  },
  {
    keywords: ["contact", "phone", "email", "support", "whatsapp", "reach", "call"],
    question: "How do I contact support?",
    answer: "Contact us:\n\n• Phone: +91 89208 93912\n• Email: Scaffoindia@gmail.com\n• WhatsApp: +91 89208 93912\n\nWe're available Monday-Saturday, 9 AM - 7 PM.",
  },
  {
    keywords: ["verify", "verified", "trusted", "authentic", "quality"],
    question: "How do you verify suppliers?",
    answer: "All suppliers go through verification:\n\n1. Business registration check\n2. GST validation\n3. Document verification\n4. Reference checks\n\nWe also track performance scores based on buyer feedback and order completion.",
  },
  {
    keywords: ["time", "response", "how long", "quick", "fast", "hours", "days"],
    question: "How quickly will I get a response?",
    answer: "We aim to respond within:\n\n• Initial acknowledgment: Within 1 hour\n• Supplier quotes: Within 24 hours\n• Urgent requirements: Even faster\n\nFor urgent needs, call us directly at +91 89208 93912.",
  },
  {
    keywords: ["login", "signin", "account", "password", "log in"],
    question: "How do I login?",
    answer: "Different login options:\n\n• Buyer login: /buyer/login\n• Supplier login: /supplier/login\n• Staff login: /staff/login\n\nChoose the appropriate portal based on your account type.",
  },
  {
    keywords: ["lead", "order", "won", "deal", "complete", "quotation"],
    question: "What happens after I win a lead?",
    answer: "After winning a lead:\n\n1. You'll be notified via email/SMS\n2. Contact the buyer directly\n3. Discuss delivery details\n4. Complete the order\n5. Get paid as per terms\n\nOur team is available to assist if any issues arise.",
  },
  {
    keywords: ["about", "company", "who", "what is", "us", "aboutus"],
    question: "What is Scaffoindia?",
    answer: "Scaffoindia is India's scaffolding RFQ platform - connecting project teams with verified suppliers through structured requirements and competitive quotes.\n\nWe help buyers find the right suppliers and help suppliers grow their business with quality leads.\n\nLearn more: /about-us",
  },
  {
    keywords: ["blog", "article", "news", "update", "post", "read"],
    question: "Do you have a blog?",
    answer: "Yes! Visit /blog for:\n\n• Industry news\n• Construction tips\n• Supplier highlights\n• Material guides\n\nWe regularly publish helpful articles for buyers and suppliers.",
  },
  {
    keywords: ["contact us", "contactus", "reach", "get in touch"],
    question: "How can I contact you?",
    answer: "You can reach us at:\n\n• Contact page: /contact-us\n• Phone: +91 89208 93912\n• Email: Scaffoindia@gmail.com\n\nFill out the contact form at /contact-us and we'll get back to you within 24 hours.",
  },
  {
    keywords: ["terms", "condition", "t&c", "term"],
    question: "What are the terms and conditions?",
    answer: "You can read our Terms and Conditions at:\n\n/terms-and-conditions\n\nThis outlines the rules for using our platform, including user responsibilities, privacy, and dispute resolution.",
  },
  {
    keywords: ["privacy", "policy", "data", "information"],
    question: "What is your privacy policy?",
    answer: "Our Privacy Policy is available at:\n\n/privacy-policy\n\nWe explain how we collect, use, and protect your personal information. Your data is secure with us.",
  },
  {
    keywords: ["buyer", "purchase", "procurement"],
    question: "How do I buy materials?",
    answer: "As a buyer:\n\n1. Post your requirement at /materials\n2. Get quotes from suppliers\n3. Compare prices and ratings\n4. Choose the best option\n5. Contact supplier to finalize\n\nIt's free to post requirements!",
  },
  {
    keywords: ["seller", "supplier", "list business", "grow business"],
    question: "How do I become a supplier?",
    answer: "To become a supplier:\n\n1. Visit /supplier/login\n2. Click 'Register as Supplier'\n3. Complete registration\n4. Wait for verification\n5. Start receiving leads!\n\nRegistration is free. We take a small commission only on successful orders.",
  },
  {
    keywords: ["gst", "tax", "document", "registration certificate"],
    question: "What documents do I need?",
    answer: "Required documents:\n\n• GST Registration\n• Business Registration (ROC)\n• ID Proof\n• Address Proof\n\nThese help us verify your business authenticity.",
  },
  {
    keywords: ["profile", "account", "manage", "edit"],
    question: "How do I manage my profile?",
    answer: "To manage your profile:\n\n• Buyers: /account\n• Suppliers: /supplier\n\nUpdate your details, view leads, and manage your account settings from these dashboards.",
  },
  {
    keywords: ["password", "forgot", "reset", "change"],
    question: "How do I reset my password?",
    answer: "To reset your password:\n\n1. Go to login page\n2. Click 'Forgot Password'\n3. Enter your email\n4. Check for reset link\n5. Create new password\n\nIf you need help, contact support.",
  },
];

export function findFAQ(query) {
  const q = query.toLowerCase().trim();
  if (!q) return null;

  let bestMatch = null;
  let bestScore = 0;

  for (const faq of faqData) {
    for (const keyword of faq.keywords) {
      if (q.includes(keyword)) {
        const score = keyword.length;
        if (score > bestScore) {
          bestScore = score;
          bestMatch = faq;
        }
      }
    }
  }

  return bestMatch;
}

export const quickQuestions = [
  "How do I register as a supplier?",
  "How do I post a requirement?",
  "Which cities do you serve?",
  "Is there any charge to use?",
  "How do I contact support?",
  "What is Scaffoindia?",
  "How do I become a supplier?",
];